import { render, staticRenderFns } from "./ContractInformation.vue?vue&type=template&id=127963dc&scoped=true&"
import script from "./ContractInformation.vue?vue&type=script&lang=js&"
export * from "./ContractInformation.vue?vue&type=script&lang=js&"
import style0 from "./ContractInformation.vue?vue&type=style&index=0&id=127963dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127963dc",
  null
  
)

export default component.exports